import { render, staticRenderFns } from "./mistakeRecord.vue?vue&type=template&id=3a70c6b1&scoped=true&"
import script from "./mistakeRecord.vue?vue&type=script&lang=js&"
export * from "./mistakeRecord.vue?vue&type=script&lang=js&"
import style0 from "./mistakeRecord.vue?vue&type=style&index=0&id=3a70c6b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70c6b1",
  null
  
)

export default component.exports